import React from 'react';
import { Button, Input, Popover } from 'antd';

const RemarkEditPopover = ({ open, initialRemark, onOpenChange, onSave, loading, children }) => {
  const [value, setValue] = React.useState(initialRemark || '');

  React.useEffect(() => {
    if (open) {
      setValue(initialRemark || '');
    }
  }, [open, initialRemark]);

  return (
    <Popover
      content={
        <div style={{ width: 220 }}>
          <Input.TextArea
            rows={2}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="Enter remark"
            style={{ marginBottom: 8 }}
          />
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button size="small" onClick={() => onOpenChange(false)} disabled={loading}>Cancel</Button>
            <Button size="small" type="primary" onClick={() => onSave(value)} loading={loading}>Save</Button>
          </div>
        </div>
      }
      title="Edit Remark"
      trigger="click"
      open={open}
      onOpenChange={onOpenChange}
    >
      {children}
    </Popover>
  );
};

export default RemarkEditPopover;
